// import { getLocal } from "@/common/js";
// const profileExists = getLocal("dsj_profileExists");
// const roleId = parseInt(getLocal("dsj_roleId"));
let _rUrl = '/info/xtj';
// if(profileExists == 'true') {
//   if(roleId == 6) {
//     _rUrl = '/info/detail/counsellor'
//   }

//   if(2< roleId && roleId < 6) {
//     _rUrl = '/info/detail/zf'
//   }
// }
const routes = [
  {
  path: '/',
  redirect: _rUrl
},
{
  path: '/login',
  name: 'login',
  component: () => import( /* webpackChunkName: "login" */ '@/views/login'),
  meta: {
    requiresAuth: false,
    title: "登录",
    index: 1
  },
},
{
  path: '/forgetPassword',
  name: 'forgetPassword',
  component: () => import( /* webpackChunkName: "user" */ '@/views/forgetPassword'),
  meta: {
    requiresAuth: false,
    title: "忘记密码",
    index: 2
  },
},
{
  path: '/updatePasswrod',
  name: 'updatePasswrod',
  component: () => import( /* webpackChunkName: "user" */ '@/views/updatePassword'),
  meta: {
    requiresAuth: true,
    title: "修改密码",
    index: 2
  },
},
{
  path: '/error',
  name: 'error',
  component: () => import( /* webpackChunkName: "info" */ '@/views/error'),
  meta: {
    requiresAuth: true,
    title: "页面错误",
    index: 1
  },
},
{
  path: '/info/xtj',
  name: 'xtj',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/list/xtj'),
  meta: {
    requiresAuth: true,
    title: "新统计",
    index: 1
  },
}, {
  path: '/info/ytj',
  name: 'ytj',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/list/ytj'),
  meta: {
    requiresAuth: true,
    title: "已提交",
    index: 1
  },
},
{
  path: '/info/wtg',
  name: 'wtg',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/list/wtg'),
  meta: {
    requiresAuth: true,
    title: "未通过",
    index: 1
  },
},
{
  path: '/info/add/form1',
  name: 'addForm1',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/form/form1'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
}, {
  path: '/info/add/form2',
  name: 'addForm2',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/form/form2'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
}, {
  path: '/info/add/form3',
  name: 'addForm3',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/form/form3'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
}, {
  path: '/info/add/form4',
  name: 'addForm4',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/form/form4'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
}, {
  path: '/info/add/form5',
  name: 'addForm5',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/form/form5'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
},{
  path: '/info/add/form6',
  name: 'addForm6',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/form/form6'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
},{
  path: '/info/add/form31',
  name: 'addForm31',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/form/form7'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
},{
  path: '/info/add/form36',
  name: 'addForm36',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/form/form8'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
},{
  path: '/info/add/form37',
  name: 'addForm37',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/form/form9'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
},{
  path: '/info/add/form38',
  name: 'addForm38',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/form/form10'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
},{
  path: '/info/add/form39',
  name: 'addForm39',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/form/form11'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
},{
  path: '/info/add/form40',
  name: 'addForm40',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/form/form12'),
  meta: {
    requiresAuth: true,
    title: "信息填报",
    index: 1
  },
},{
  path: '/info/detail/form1',
  name: 'detailForm1',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/detail/form1'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/form2',
  name: 'detailForm2',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/detail/form2'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/form4',
  name: 'detailForm4',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/detail/form4'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/form5',
  name: 'detailForm5',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/detail/form5'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/form6',
  name: 'detailForm6',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/detail/form6'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/form31',
  name: 'detailForm31',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/detail/form7'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/form36',
  name: 'detailForm36',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/detail/form8'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/form37',
  name: 'detailForm37',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/detail/form9'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
}, {
  path: '/info/detail/form38',
  name: 'detailForm38',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/detail/form10'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/form39',
  name: 'detailForm39',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/detail/form11'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/form40',
  name: 'detailForm40',
  component: () => import( /* webpackChunkName: "info" */ '@/views/information/detail/form12'),
  meta: {
    requiresAuth: true,
    title: "信息",
    index: 1
  },
},{
  path: '/info/detail/counsellor',
  name: 'counsellor',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/detail/counsellor'),
  meta: {
    requiresAuth: true,
    title: "辅导员",
    index: 1
  },
}, {
  path: '/info/detail/zf',
  name: 'zf',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/detail/zf'),
  meta: {
    requiresAuth: true,
    title: "总辅",
    index: 1
  },
}, {
  path: '/info/detail',
  name: 'infoDetail',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/detail'),
  meta: {
    requiresAuth: true,
    title: "信息详情",
    index: 2
  },
},
{
  path: '/info/add',
  name: 'addInfo',
  component: () => import( /* webpackChunkName: "form" */ '@/views/information/detail/add.vue'),
  meta: {
    requiresAuth: true,
    title: "填报信息",
    index: 2
  },
}, {
  path: '/organization/management',
  name: 'management',
  component: () => import( /* webpackChunkName: "info" */ '@/views/organization/management'),
  meta: {
    requiresAuth: true,
    title: "组织管理",
    index: 1
  },
},
{
  path: '/organization/infoStatistics',
  name: 'infoStatistics',
  component: () => import( /* webpackChunkName: "organization" */ '@/views/organization/infoStatistics'),
  meta: {
    requiresAuth: true,
    title: "信息统计结果",
    index: 2
  },
},
{
  path: '/setting',
  name: 'setting',
  component: () => import( /* webpackChunkName: "setting" */ '@/views/setting'),
  meta: {
    requiresAuth: true,
    title: "设置",
    index: 2
  },
}, {
  path: '/organization/auditor',
  name: 'auditor',
  component: () => import( /* webpackChunkName: "organization"*/ '@/views/organization/auditor'),
  meta: {
    requiresAuth: true,
    title: "审核填报信息",
    index: 2,
    keepAlive: true,
  }
}, {
  path: '/organization/auditor/detail',
  name: 'auditorDetail',
  component: () => import( /* webpackChunkName: "organization"*/ '@/views/organization/auditor/edit.vue'),
  meta: {
    requiresAuth: true,
    title: "审核填报信息详情",
    index: 2
  }
}, {
  path: '/organization/mailList',
  name: 'mailList',
  component: () => import( /* webpackChunkName: "organization"*/ '@/views/organization/mailList'),
  meta: {
    requiresAuth: true,
    title: "通讯录",
    index: 2
  }
}, {
  path: '/organization/adminAccount',
  name: 'adminAccount',
  component: () => import( /* webpackChunkName: "organization"*/ '@/views/organization/adminAccount'),
  meta: {
    requiresAuth: true,
    title: "管理成员账号",
    index: 2
  }
}, {
  path: '/organization/adminAccount/add',
  name: 'addAccount',
  component: () => import( /* webpackChunkName: "organization"*/ '@/views/organization/adminAccount/add.vue'),
  meta: {
    requiresAuth: true,
    title: "添加成员账号",
    index: 2
  }
}, {
  path: '/organization/adminAccount/edit',
  name: 'editAccount',
  component: () => import( /* webpackChunkName: "organization"*/ '@/views/organization/adminAccount/edit.vue'),
  meta: {
    requiresAuth: true,
    title: "修改成员账号",
    index: 2
  }
}, 
// {
//   path: '/test',
//   name: 'test',
//   component: () => import( /* webpackChunkName: "test"*/ '@/views/test.vue'),
//   meta: {
//     requiresAuth: true,
//     title: "测试",
//     index: 1
//   }
// }, 
{
  path: '/error',
  name: 'error',
  component: () => import( /* webpackChunkName: "test"*/ '@/views/error.vue'),
  meta: {
    requiresAuth: true,
    title: "失败",
    index: 1
  }
}, {
  path: '/school',
  name: 'school',
  component: () => import( /* webpackChunkName: "search"*/ '@/views/school/index.vue'),
  meta: {
    requiresAuth: true,
    title: "学校",
    index: 2
  }
}
]
export default routes;